<div class="ancillary-summary" data-testid="ancillary-summary">
  <h3 class="font-body-1">{{ title | finLocalization: [] : { logErrors: false } }}</h3>
  <div
    class="summary-info"
    *ngFor="let paxService of (service$ | async).passengers; first as isFirst; last as isLast"
    [class.ms-xsmall-b]="!isLast"
    [class.ms-xsmall-t]="isFirst"
  >
    <div class="capitalize nordic-blue-900-text" data-hj-suppress>
      <span *ngIf="!(service$ | async).isGroupService">{{ paxService.firstName }} {{ paxService.lastName }}</span>
      <span *ngIf="(service$ | async).isGroupService">{{ 'ancillaries.group.title' | finLocalization }}</span>
    </div>
    <div class="nordic-blue-900-text" *ngIf="paxService.associatedInfantName" data-hj-suppress>
      {{ 'passenger.withInfant' | finLocalization: { withInfantFullName: paxService.associatedInfantName } }}
    </div>
    <div class="regular-type">
      {{
        paxService.key
          | finLocalization
            : {
                wifiCount: paxService.quantity,
                loungeCount: paxService.quantity,
                mealCount: paxService.quantity,
                baggageCount: paxService.quantity,
                seatCount: paxService.quantity,
                coverCount: paxService.quantity,
                sportCount: paxService.quantity,
                petCount: paxService.quantity,
                bundleCount: paxService.quantity,
                amount: paxService.quantity,
              }
      }}: {{ paxService.price | finPrice }}
    </div>
  </div>
</div>
